import UIDs from "../../../../UIDs";

const uid = UIDs.screens.account.login;

const ActionTypes = {
    // Initialize
    INITIALIZE_ASYNC: `${uid}.initializeAsync`,
    INITIALIZE_SUCCESS: `${uid}.initializeSuccess`,
    INITIALIZE_FAILURE: `${uid}.initializeFailure`,

    // Login
    LOGIN_ASYNC: `${uid}.loginAsync`,
    LOGIN_SUCCESS: `${uid}.loginSuccess`,
    LOGIN_FAILURE: `${uid}.loginFailure`,

    // Validate Password
    VALIDATE_PASSWORD_ASYNC: `${uid}.validatePasswordAsync`,
    VALIDATE_PASSWORD_SUCCESS: `${uid}.validatePasswordSuccess`,
    VALIDATE_PASSWORD_FAILURE: `${uid}.validatePasswordFailure`,

    // Get Schools
    GET_SCHOOLS_ASYNC: `${uid}.getSchoolsAsync`,
    GET_SCHOOLS_SUCCESS: `${uid}.getSchoolsSuccess`,
    GET_SCHOOLS_FAILURE: `${uid}.getSchoolsFailure`,

    // Init School Login
    INIT_SCHOOL_LOGIN_ASYNC: `${uid}.initSchoolLoginAsync`,
    INIT_SCHOOL_LOGIN_SUCCESS: `${uid}.initSchoolLoginSuccess`,
    INIT_SCHOOL_LOGIN_FAILURE: `${uid}.initSchoolLoginFailure`,

    // Resend Email
    RESEND_EMAIL_ASYNC: `${uid}.resendEmailAsync`,
    RESEND_EMAIL_SUCCESS: `${uid}.resendEmailSuccess`,
    RESEND_EMAIL_FAILURE: `${uid}.resendEmailFailure`,

    // Activate Member
    ACTIVATE_MEMBER_ASYNC: `${uid}.activateMemberAsync`,
    ACTIVATE_MEMBER_SUCCESS: `${uid}.activateMemberSuccess`,
    ACTIVATE_MEMBER_FAILURE: `${uid}.activateMemberFailure`,

    // Change Login School
    CHANGE_LOGIN_SCHOOL_ASYNC: `${uid}.changeLoginSchoolAsync`,
    CHANGE_LOGIN_SCHOOL_SUCCESS: `${uid}.changeLoginSchoolSuccess`,
    CHANGE_LOGIN_SCHOOL_FAILURE: `${uid}.changeLoginSchoolFailure`,

    GET_MATCHED_SCHOOLS_ASYNC: `${uid}.getMatchedSchoolsAsync`,
    GET_MATCHED_SCHOOLS_SUCCESS: `${uid}.getMatchedSchoolsSuccess`,
    GET_MATCHED_SCHOOLS_FAILURE: `${uid}.getMatchedSchoolsFailure`,

    DOWNLOAD_DATA_ASYNC: `${uid}.downloadDataAsync`,
    DOWNLOAD_DATA_SUCCESS: `${uid}.downloadDataSuccess`,
    DOWNLOAD_DATA_FAILURE: `${uid}.downloadDataFailure`,

    // Add new action types for login flow
    SELECT_SCHOOL: `${uid}.selectSchool`,

    // Add screen state action type
    UPDATE_SCREEN_STATE: `${uid}.updateScreenState`,
};

export { ActionTypes };
